import Image, { getImageProps } from "next/image";
import { SymptomSlide } from "./data";
import Lead from "~/componentsDS/Typography/Lead";
import Quote from "@/icons/ui/quotation-mark.svg";
import Overline from "~/componentsDS/Typography/Overline";
import { cn } from "~/lib/utils";

type ExpertQuoteCardProps = {
    slide: SymptomSlide;
    isActive: boolean;
    keepAuthorAlt: boolean;
};

export const ExpertQuoteCard = ({ slide, isActive, keepAuthorAlt }: ExpertQuoteCardProps) => {
    const { quote, authorImageUrl } = slide;
    const authorAlt = keepAuthorAlt ? "Dr. Sarah Daccarett, MD" : "";
    const {
        props: desktopAuthorImageProps,
    } = getImageProps({
        src: authorImageUrl.desktop,
        alt: authorAlt,
        fill: true,
        sizes: "400px",
    });

    return (
        <aside
            className={cn(
                "relative flex flex-col overflow-hidden rounded-2xl bg-trueBlack/10 p-6 text-pureWhite backdrop-blur-[25px]",
                "max-lg:transition-[opacity,transform] max-lg:duration-500 max-lg:ease-out motion-reduce:transition-none",
                isActive
                    ? "max-lg:translate-y-0 max-lg:opacity-100"
                    : "max-lg:pointer-events-none max-lg:translate-y-4 max-lg:opacity-0",
                "lg:h-[562px] lg:bg-oestra400/25",
            )}
        >
            <Quote className="relative z-10 w-8 h-8 shrink-0 mb-4 lg:hidden" />

            <Lead font="featureDisplay" className="relative z-10 mb-4 lg:mb-8 text-[24px] tracking-[0.48px] lg:tracking-[0.56px]">
                <span className="absolute -translate-x-full max-lg:hidden">“</span>
                {quote}
                <span className="hidden lg:inline">”</span>
            </Lead>

            <div className="relative z-10 mt-auto flex items-center gap-[10px] lg:static lg:mt-0 lg:block">
                <div className="relative size-10 shrink-0 overflow-hidden rounded-full lg:absolute lg:inset-0 lg:size-auto lg:rounded-none pointer-events-none">
                    <picture>
                        <source
                            media="(min-width: 1024px)"
                            srcSet={desktopAuthorImageProps.srcSet}
                            sizes={desktopAuthorImageProps.sizes}
                        />
                        <Image
                            src={authorImageUrl.mobile}
                            alt={authorAlt}
                            fill
                            sizes="(max-width: 1023px) 80px, 400px"
                            loading="lazy"
                            className="object-cover object-center lg:object-contain lg:object-right-bottom"
                        />
                    </picture>
                </div>
                <Overline
                    as="span"
                    size="lg"
                    weight="500"
                    className="block relative z-10"
                >
                    <span className="block lg:mb-1">Dr. Sarah Daccarett, MD</span>
                    <Overline as="span" size="sm" className="block">
                        CEO & Founder of Inner Balance
                    </Overline>
                </Overline>
            </div>
        </aside>
    );
}
